import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationState } from './notification.models';

export const selectNotification =
  createFeatureSelector<NotificationState>('notification');

export const selectAllComplianceNotifications = createSelector(
  selectNotification,
  (state: NotificationState) => state.complianceNotificationStatus,
);

export const selectMostImportantComplianceNotification = createSelector(
  selectNotification,
  (state: NotificationState) => state.topPriorityComplianceNotification,
);

export const selectAllTrainingNotifications = createSelector(
  selectNotification,
  (state: NotificationState) => state.trainingNotificationStatus,
);

export const selectMostImportantTrainingNotification = createSelector(
  selectNotification,
  (state: NotificationState) => state.topPriorityTrainingNotification,
);
